//src/styles/components/MuiGrid.js

const MuiGrid = {
  styleOverrides: {
    root: ({ theme }) => ({ 
      transition: theme?.transitions?.default || "all 0.3s ease" 
    })
  },
};

export default MuiGrid;